import { reveal } from "@components/animations";
import { Box, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function ForwardBtn({
  title,
  href,
  isShowBackBtn = true,
}: IForwardBtn) {
  return (
    <Stack
      {...reveal("up")}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography
          // Section titles are the page's second-level headings. They used to
          // be plain divs, so screen readers got an outline of one h1 and then
          // nothing until the cards (Lighthouse: heading-order).
          component="h2"
          color="primary.main"
          fontWeight={500}
          fontSize={{
            xs: "h3.fontSize",
            sm: "h2.fontSize",
            md: "h1.fontSize",
          }}
        >
          #
          <Typography
            component={"span"}
            color="text.primary"
            fontWeight={500}
            fontSize={{
              xs: "body1.fontSize",
              sm: "h2.fontSize",
              md: "h1.fontSize",
            }}
          >
            {title}
          </Typography>
        </Typography>
        <Box
          sx={{
            width: {
              xs: "10px",
              sm: "40px",
              md: "60px",
              lg: "100px",
            },
            height: "1.5px",
            backgroundColor: (theme) => theme.palette.primary.main,
          }}
        />
      </Stack>
      {isShowBackBtn && href && (
        <Typography
          fontWeight={400}
          fontSize={{
            xs: 10,
            sm: 16,
          }}
          color="text.primary"
          component={Link}
          to={href}
          sx={{
            borderBottom: (theme) => `2px solid ${theme.palette.primary.main}`,
            transition: "transform 0.3s ease, color 0.3s ease",
            "&:hover": {
              color: "#C778DD",
              transform: "translateX(4px)",
            },
          }}
        >
          View all ~~{">"}
        </Typography>
      )}
    </Stack>
  );
}
